import { render, staticRenderFns } from "./SchoolVerificationIndicator.vue?vue&type=template&id=204d78ee&scoped=true"
import script from "./SchoolVerificationIndicator.vue?vue&type=script&lang=ts"
export * from "./SchoolVerificationIndicator.vue?vue&type=script&lang=ts"
import style0 from "./SchoolVerificationIndicator.vue?vue&type=style&index=0&id=204d78ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204d78ee",
  null
  
)

export default component.exports